<agpr-panel
    class="agpr-briefing-config-preferences"
    header="AMT.briefingConfig"
>
    <agpr-number-input
        id="briefingConfigs_alertLimit"
        class="agpr-briefing-config-preferences-alertLimit"
        [(ngModel)]="alertLimit"
        label="AMT.alertLimit.alertLimit"
        placeholder="AMT.alertLimit.enterLimit"
        tooltip="AMT.alertLimit.tooltip"
        [integerOnly]="true"
        [forceMinValue]="false"
        (blur)="checkAlertLimit()"
        (ngModelChange)="checkActiveAlertTotal()"
        [min]="-1"
        [max]="999999999"
    ></agpr-number-input>

    @if(showWarningMessage) {
        <agpr-form-message>
            {{ 'AMT.alertLimit.limitWarning' | localize : { count: briefingConfigs?.activeAlertTotal } }}
        </agpr-form-message>
    }
</agpr-panel>
